import React, { useEffect, useState } from "react";

// Components
import NavbarAndSidebarLayout from "~/layouts/NavbarAndSidebarLayout";
import PageHeader from "~/common/components/PageHeader";
import ModalTemplate from "~/common/components/ModalPortal/ModalTemplate";
import DropdownTemplate from "~/common/components/DropdownPortal/DropdownTemplate";

// Assets
import "~/assets/sass/pages/mypage/signature/signature.scss";
import SignaturePolicyModal from "./modal/policy/SignaturePolicyModal";
import SignatureUploadModal from "./modal/upload/SignatureUploadModal";
import useRequest from "~/common/hooks/useRequest";
import { API_STATE } from "~/common/constants/state";
import { dateToString } from "~/utils/formatter";
import { getTitle } from "~/utils/getTitle";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

const SignaturePage = () => {
	const { t } = useTranslation();
	const MENU = ["account", "signature"];
	const TYPE = "myPage";
	const [signatureList, setSignatureList] = useState([]);

	const [digitalDataModal, setDigitalDataModalModal] = useState(false);
	const [signatureUploadModal, setSignatureUploadModal] = useState(false);

	const userSignatureRequest = useRequest("get", "vc/user/signature");
	const deleteSignatureRequest = useRequest("delete", `vc/user/signature/delete`);
	const activationSignatureRequest = useRequest("post", `vc/user/signature/activation`);
	const [deleteSignIdx, setDeleteSignIdx] = useState("");
	const [activeSignIdx, setActiveSignIdx] = useState("");

	useEffect(() => {
		userSignatureRequest.singleCall();
	}, [userSignatureRequest]);

	useEffect(() => {
		switch (userSignatureRequest.state) {
			case API_STATE.done:
				const newData = userSignatureRequest.response.data.map((d) => ({
					...d,
					updateDate: dateToString(d.updateDate, "yyyy-MM-dd"),
				}));

				setSignatureList(newData);
				break;
			case API_STATE.error:
				console.log("error", userSignatureRequest.error);
				break;
			default:
				break;
		}
	}, [userSignatureRequest.state, userSignatureRequest.error, userSignatureRequest.response]);

	const handleDelete = (idx) => {
		setDeleteSignIdx(idx);
	};

	useEffect(() => {
		if (deleteSignIdx !== "") {
			deleteSignatureRequest.call(deleteSignIdx, "path");
			setDeleteSignIdx("");
		}
	}, [deleteSignIdx, deleteSignatureRequest]);

	useEffect(() => {
		switch (deleteSignatureRequest.state) {
			case API_STATE.done:
				userSignatureRequest.call();
				break;
			case API_STATE.error:
				console.log("error", deleteSignatureRequest.error);
				break;
			default:
				break;
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		deleteSignatureRequest.state,
		deleteSignatureRequest.error,
		deleteSignatureRequest.response,
	]);

	const handleActive = (idx) => {
		setActiveSignIdx(idx);
	};

	useEffect(() => {
		if (activeSignIdx !== "") {
			setActiveSignIdx("");
			activationSignatureRequest.call(activeSignIdx, "path");
		}
	}, [activeSignIdx, activationSignatureRequest]);

	useEffect(() => {
		switch (activationSignatureRequest.state) {
			case API_STATE.done:
				userSignatureRequest.call();
				break;
			case API_STATE.error:
				console.log("error", activationSignatureRequest.error);
				break;
			default:
				break;
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [
		activationSignatureRequest.state,
		activationSignatureRequest.error,
		activationSignatureRequest.response,
	]);

	const headerButtons = [
		<button
			type="button"
			className="btn__solid"
			color="primary"
			onClick={() => setDigitalDataModalModal(true)}
		>
			{t("common.commonWord.button.add")}
		</button>,
	];

	return (
		<>
			<Helmet>
				<title>{getTitle("개인서명 관리")}</title>
			</Helmet>
			<NavbarAndSidebarLayout menu={MENU} type={TYPE}>
				<PageHeader hasBreadCrumb={true} buttonList={headerButtons} />
				<div className="c__cardRow">
					{signatureList &&
						signatureList.map((sign) => (
							<div
								className={`c__card ${sign.activation && "active"}`}
								key={sign.idx}
							>
								{sign.activation && (
									<div className="c__badge">
										{t("common.commonWord.button.active")}
									</div>
								)}
								<DropdownTemplate target={sign.idx} vertical>
									<li
										className="c__dropdownItem"
										onClick={() => handleActive(sign.idx)}
									>
										{sign.activation
											? t("common.commonWord.button.inactive")
											: t("common.commonWord.button.active")}
									</li>
									<li
										className="c__dropdownItem"
										onClick={() => handleDelete(sign.idx)}
									>
										{t("common.commonWord.button.delete")}
									</li>
								</DropdownTemplate>
								<div className="img-wrap">
									<img
										src={sign.img}
										alt={t("pages.myPage.SignaturePage.signImg")}
										className={sign.type === "IMG" ? "sign-img" : ""}
									/>
								</div>
								<p className="date">Updated:{sign.updateDate}</p>
							</div>
							//---- Empty
							// <div className="page-init">
							// 	<p className="main">개인서명이 존재하지 않습니다.</p>
							// 	<p className="sub">
							// 		우측 상단의 추가하기를 클릭하여 개인서명을 추가해 보세요.
							// 	</p>
							// <img src={darkInitImg} alt="초기이미지" />
							// <img src={lightInitImg} alt="초기이미지" />
							// </div>
						))}
				</div>
			</NavbarAndSidebarLayout>

			{/* POLICY */}
			<ModalTemplate
				title={t("pages.myPage.SignaturePage.digitalDataModalTitle")}
				modalState={digitalDataModal}
				setModalToggle={setDigitalDataModalModal}
				width={500}
				height={502}
				className="digital-data-modal"
			>
				<SignaturePolicyModal
					setSignatureUploadModal={setSignatureUploadModal}
					setDigitalDataModalModal={setDigitalDataModalModal}
				/>
			</ModalTemplate>

			{/* UPLOAD */}
			<ModalTemplate
				title={t("pages.myPage.SignaturePage.uploadModalTitle")}
				modalState={signatureUploadModal}
				setModalToggle={setSignatureUploadModal}
				width={500}
				height={502}
				className="signatureUpload-modal"
			>
				<SignatureUploadModal
					setModalToggle={setSignatureUploadModal}
					userSignatureRequest={userSignatureRequest}
				/>
			</ModalTemplate>
		</>
	);
};
export default SignaturePage;
